import { render, staticRenderFns } from "./inputitem.vue?vue&type=template&id=2871c076&scoped=true"
import script from "./inputitem.vue?vue&type=script&lang=js"
export * from "./inputitem.vue?vue&type=script&lang=js"
import style0 from "./inputitem.vue?vue&type=style&index=0&id=2871c076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871c076",
  null
  
)

export default component.exports